import {
  ADVISOR_SET_REGION,
  ADVISOR_SET_SPORT_TYPE,
  ADVISOR_SET_SPORT_VARIANT,
  ADVISOR_UNSET_SPORT_VARIANT,
  ADVISOR_SET_PARAMETERS
} from "../../store/constants/hwk";

const initialState = {
  region: 1, //@todo set null
  sportType: 1, //@todo set null
  sportVariant: 1, //@todo set null
  parameters: {
    humidity: 40,
    temperature: 2,
    snowType: 2
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADVISOR_SET_REGION:
      return {
        ...state,
        region: action.region
      };
    case ADVISOR_SET_SPORT_TYPE:
      return {
        ...state,
        sportType: action.sportType
      };
    case ADVISOR_SET_SPORT_VARIANT:
      return {
        ...state,
        sportVariant: action.sportVariant
      };
    case ADVISOR_UNSET_SPORT_VARIANT:
      return {
        ...state,
        sportVariant: null
      };
    case ADVISOR_SET_PARAMETERS:
      return {
        ...state,
        parameters: action.parameters
      };
    default:
      return state;
  }
}
